import * as React from "react";
import { Button, FlexBox, Paragraph } from "scuid-x";
import SuccessIcon from "../assets/images/success-check-symbol.svg";
import { HeaderAndFooter } from "../components/HeaderAndFooter";
import { Routes } from "../constants/Routing";
import "./Finished.css";

export const Finished: React.SFC<any> = () => {

  let returnDevice;
  const returnHref = Routes.getReturnHref();
  if (!!returnHref) {
    returnDevice = (
      <a
        className={"Finished-return-link"}
        href={returnHref}
        target="_self"
      >
        <Button className={"Finished-return-button"}>
          Return to Application
        </Button>
      </a>
    );
  } else {
    returnDevice = (
      <h4 className={"Finished-return-statement"}>
        Please return to your logged in device to continue your application.
      </h4>
    );
  }

  return (
    <HeaderAndFooter>
      <FlexBox
        alignContent="center"
        alignItems="center"
        justifyContent="center"
        direction="column"
      >
        <img
          className={"Finished-success-icon"}
          src={SuccessIcon}
        />
        <h1 className={"Finished-heading"}>
          Document Upload Complete!
        </h1>
        <Paragraph className={"Finished-paragraph"}>
          Your documents have been successfully uploaded to your application. Let's get you back to the process now.
        </Paragraph>
        {returnDevice}
      </FlexBox>
    </HeaderAndFooter>
  );
};



// WEBPACK FOOTER //
// ./src/screens/Finished.tsx